export default "__VITE_ASSET__CZrddROo__"